<template>
  <div class="item-container" @click="goto(data.setId)">
    <div class="cover">
      <img :src="data.coverImagUrl" />
      <div class="cover-tag">
        <span
          class="cover-tag-type"
          :style="{ backgroundImage: `url(${data.tagUrl})` }"
        ></span>
        <span class="s2 t5">{{ data.tag }}</span>
      </div>
    </div>
    <div class="content pl-30 pr-30">
      <div class="t4 s8 fw-b">
        <div class="dot-wrap">
          {{ data.title }}
          <div class="dot bc1" v-if="data.isRedTip"></div>
        </div>
      </div>
      <div>{{ data.subTitle }}</div>
      <div>{{ data.authorName }}</div>
      <div class="sell-row" v-if="courseFilterType != 4">
        <span class="s8 c1 fw-b">{{
          courseFilterType === 5
            ? `${data.displayPrice}`
            : `￥${data.price.toFixed(2)}/套`
        }}</span>
        <span v-if="courseFilterType !== 5" class="s4 t3 fw-b line-row">{{
          data.originalPrice.toFixed(2)
        }}</span>
        <span class="sell-count s2 c5">
          {{
            courseFilterType === 5
              ? `${data.saledCount}人订阅`
              : `共售${data.saledCount}份`
          }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
  name: 'CourseListItem',
  props: {
    data: {
      type: Object
    },
    courseFilterType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      coverImageUrl:
        'https://emapp-static.oss-cn-shanghai.aliyuncs.com/youkantou/20200922/3bc05b744f013ba4cada4fae061e93eb.png'
    }
  },
  methods: {
    convertTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    goto(setId) {
      this.$emit('goto')
    }
  }
}
</script>
<style lang="scss" scoped>
.dot-wrap {
  position: relative;
  width: fit-content;
  .dot {
    position: absolute;
    right: -20px;
    top: -6px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    transform: scale(0.5, 0.5);
  }
}
.item-container {
  display: flex;
  //   height: 185px;
  .cover {
    height: 180px;
    width: 180px;
    position: relative;
  }
}
.cover img {
  max-width: 100%;
  height: 100%;
  border-radius: 5px;
}
.cover-tag {
  width: 90px;
  height: 36px;
  background: url('./images/tag.png') no-repeat;
  background-size: contain;
  background-position: center;
  position: absolute;
  right: 0;
  bottom: 0;
}
.cover-tag-type {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-left: 3px;
  margin-right: 3px;
  vertical-align: middle;
  background: url('./images/monthTag.png') no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
}
.cover-tag span:nth-child(2) {
  display: inline-block;
  height: 36px;
  line-height: 40px;
  position: absolute;
}
.content {
  flex: auto;
}
.content div:nth-child(2) {
  font-size: 24px;
  color: #858585;
  margin-top: 23px;
}
.content div:nth-child(3) {
  font-size: 24px;
  color: #858585;
  margin-top: 15px;
}
.content div:nth-child(4) {
  margin-top: 27px;
}
.sell-row span:nth-child(2) {
  margin-left: 10px;
}
.line-row {
  text-decoration: line-through;
}
.sell-count {
  float: right;
  background-color: rgba($color: #046bcc, $alpha: 0.1);
  border-radius: 5px;
  width: 120px;
  height: 44px;
  line-height: 44px;
  text-align: center;
}
.flx {
  display: flex;
}
.flx-col {
  display: flex;
  flex-direction: column;
}
.split-line {
  height: 1px;
  background-color: #ebebeb;
}
.split-line-20 {
  height: 20px;
  background-color: #f0f0f0;
}
.mr-10 {
  margin-right: 10px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-40 {
  margin-top: 40px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-40 {
  margin-bottom: 40px;
}
.ml-14 {
  margin-left: 14px;
}
.ml-20 {
  margin-left: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.mr-30 {
  margin-right: 30px;
}
.pl-30 {
  padding-left: 30px;
}
.fw-b {
  font-weight: bold;
}
.fl-l {
  float: left;
}
.fl-r {
  float: right;
}
</style>
